import React from "react";
import { Chip } from "@mui/material";
import type { PortalUserView } from "../../../../services/ProfileService/types/portalUserTypes";

interface PortalUserStatusChipProps {
  status: PortalUserView["status"];
  expiresAt?: string | null;
}

const statusConfig: Record<string, { color: "success" | "warning" | "error"; label: (expiresAt?: string | null) => string }> = {
  Active: {
    color: "success",
    label: () => "Active",
  },
  Pending: {
    color: "warning",
    label: (expiresAt) => expiresAt ? `Pending — expires ${expiresAt.split("T")[0]}` : "Pending",
  },
  Disabled: {
    color: "error",
    label: () => "Disabled",
  },
};

export function PortalUserStatusChip({ status, expiresAt }: PortalUserStatusChipProps) {
  const config = statusConfig[status] || { color: "default" as const, label: () => status };
  const label = config.label(expiresAt);

  return (
    <Chip
      label={label}
      color={config.color}
      size="small"
      variant="outlined"
      aria-label={`Status: ${label}`}
    />
  );
}
